import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetAllResults = async (idCenter, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ReportExportAll"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ReportExportAll", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetAllResults - DL Results', error)
    }
}

const GetFilteredResults = async (center, group, course, block, ztudent = null, page, pageSize, token) => {
    try {
        let dataToSend

        if (ztudent) {
            dataToSend = {
                idCenter: center,
                groupId: group,
                courseId: course,
                blockId: block,
                idZtudiante: ztudent,
                page: page,
                pageSize: pageSize
            }
        } else {
            dataToSend = {
                idCenter: center,
                groupId: group,
                courseId: course,
                blockId: block,
                page: page,
                pageSize: pageSize
            }
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ReportAttemptsGrouped"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ReportAttemptsGrouped", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetFilteredResults - DL', error)
    }
}

const GetReportDetails = async (idCenter, centerName, student, course, groupId, groupName, attemptNumber, evaluationToken, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            centerName: centerName,
            studentId: student,
            courseId: course,
            token: evaluationToken,
            groupId: groupId,
            groupName: groupName,
            attemptNumber: attemptNumber
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ReportAttemptDetail"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ReportAttemptDetail", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetReportDetails - DL Results', error)
    }
}

export { GetAllResults, GetFilteredResults, GetReportDetails };